import { ComponentType } from 'react'
import { AllCardsType } from '../../../data/all-cards'
import PhotoCards10 from '../../../components/photo-cards/photo-cards-10'
import PhotoGral from '../../consultas/gral/photo-cards'
import PhotoVidaPasada from '../../consultas/vida-pasada/photo-cards'
import PhotoEvolutivo from '../../consultas/evolutivo/photo-cards'
import PhotoExPareja from '../../consultas/ex-pareja/photo-cards'
import PhotoProteccion from '../../consultas/proteccion/photo-cards'
import PhotoRenacer from '../../consultas/renacer/photo-cards'
import { ShowCards as ShowCards10 } from '../../consultas/yo-futuro/show-cards'
import { ShowCards as ShowCardsGral } from '../../consultas/gral/show-cards'
import { ShowCards as ShowCardsVidaPasada } from '../../consultas/vida-pasada/show-cards'
import { ShowCards as ShowCardsEvolutivo } from '../../consultas/evolutivo/show-cards'
import { ShowCards as ShowCardsExPareja } from '../../consultas/ex-pareja/show-cards'
import { ShowCards as ShowCardsProteccion } from '../../consultas/proteccion/show-cards'
import { ShowCards as ShowCardsRenacer } from '../../consultas/renacer/show-cards'

type PhotoProps = { cards: AllCardsType[]; mazo: string; tapiz: string }
type ShowProps = { selectedCards: AllCardsType[]; mazo: string }

export type ComboCardLayout = {
    Photo: ComponentType<PhotoProps>
    Show: ComponentType<ShowProps>
}

const LAYOUT_10: ComboCardLayout = { Photo: PhotoCards10, Show: ShowCards10 }

const LAYOUTS: Record<string, ComboCardLayout> = {
    amor: LAYOUT_10,
    celta: LAYOUT_10,
    abundancia: LAYOUT_10,
    trabajo: LAYOUT_10,
    infidelidad: LAYOUT_10,
    futuro: LAYOUT_10,
    autoconocimiento: LAYOUT_10,
    atraccion: LAYOUT_10,
    general: { Photo: PhotoGral, Show: ShowCardsGral },
    vidapasada: { Photo: PhotoVidaPasada, Show: ShowCardsVidaPasada },
    evolutivo: { Photo: PhotoEvolutivo, Show: ShowCardsEvolutivo },
    'ex-pareja': { Photo: PhotoExPareja, Show: ShowCardsExPareja },
    proteccion: { Photo: PhotoProteccion, Show: ShowCardsProteccion },
    renacer: { Photo: PhotoRenacer, Show: ShowCardsRenacer },
}

/** Elige layout de foto/pantalla según la tirada del paso (no siempre es de 10 cartas). */
export const getComboCardLayout = (
    spreadId?: string,
    cardCount?: number
): ComboCardLayout => {
    if (spreadId && LAYOUTS[spreadId]) return LAYOUTS[spreadId]
    if (cardCount === 26) return LAYOUTS.renacer
    if (cardCount === 25) return LAYOUTS.general
    if (cardCount === 14) return LAYOUTS.evolutivo
    if (cardCount === 7) return LAYOUTS.proteccion
    return LAYOUT_10
}
